/* 
Author:Lamiaa Moustafa
Desc: Reusable Radio button component 
*/

import React from "react";
import styled from "styled-components";

const RadioButton = (props) => {
  const { name, type, value, label, onChange, checked, customStyle } =
    props.data;
  return (
    <RadioDiv>
      <RadioBtn
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        checked={checked}
        style={customStyle}
      ></RadioBtn>
      <label>{label}</label>
    </RadioDiv>
  );
};
export default RadioButton;

const RadioBtn = styled.input`
  border-radius: 50%;
  width: 20px;
  height: 20px;
  margin: 0 10px 0 40px;
  z-index: 99;
  cursor: pointer;
  &:hover {
    background: #f1e9e9;
    &::after {
      content: "";
      display: block;
      border-radius: 50%;
      width: 16px;
      height: 16px;
      border:2px solid var(--orange);
      background: var(--white);
    }
  }
  &:checked {
    background: var(--lightGray);
    border: 1px solid var(--orange);
    &::after {
      content: "";
      display: block;
      border-radius: 50%;
      width: 16px;
      height: 16px;
       border:2px solid var(--white);
      background: var(--orange);
      outline:none;
    }
  }
 
`;
const RadioDiv = styled.div`
  z-index: 99;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 15px;
  label {
    color: var(--white);
    font-family: var(--fontFamily);
    font-weight: 500;
    font-size: 18px;
    letter-spacing: 1.5px;
  }
`;
